import Button from "@components/button/button";
import { ButtonSize, buttonTheme } from "@components/button/button-constants";
import { getAssetUrl } from "@helpers/helpers";

const IntegrationCard = ({
  name,
  logo,
  description,
  category,
  isLoading,
  onConnect,
}: {
  name: string;
  logo: string;
  description: string | JSX.Element;
  category?: string;
  isLoading?: boolean;
  onConnect: () => void;
}) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 flex flex-col items-center hover:border-gray-300 hover:shadow-sm transition-all">
      <div className="h-16 w-16 flex-shrink-0 border rounded p-2 flex items-center justify-center bg-white mb-3">
        <img
          src={getAssetUrl(logo)}
          alt={name}
          className="h-full w-full object-contain"
        />
      </div>
      <h4 className="text-sm font-semibold text-gray-900 text-center mb-2">
        {name}
      </h4>
      {category && (
        <div className="text-xs text-gray-400 text-center mb-2 capitalize">
          {category}
        </div>
      )}
      <div className="text-xs text-gray-500 flex-1 mb-4 overflow-hidden w-full">
        {description}
      </div>
      <Button
        theme={isLoading ? buttonTheme.iconGray : buttonTheme.lightBlue}
        size={ButtonSize.medium}
        className="w-full justify-center h-10"
        onClick={onConnect}
        disabled={isLoading}
      >
        {isLoading ? "Connecting..." : "Connect"}
      </Button>
    </div>
  );
};

export default IntegrationCard;
